import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const ScoreChart = ({ currentRange }) => {

  const [chartData, setChartData] = useState({
    series: [
      {
        name: "Score",
        data: [],
      },
    ],
    options: {
      chart: {
        type: "bar", 
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 1,
        lineCap: "round",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5,
        },
      },
      xaxis: {
        //categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      },
      colors: ["#42BA5C"],
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.3,
          stops: [0, 90, 100],
        },
      },
    },
  });

  const userData = useSelector((state) => state.userSlice);

  const configData = useSelector((state) => state.configSlice);

  var uuid = userData?.user?.uuid;

  const { id } = useParams();

  const navigate = useNavigate();

  const fetchinsightgraph = async () => {
    if (!id || !uuid) {
      console.error('Invalid id or uuid');
      return;
    }

    try {
      const response = await axios.get(
        `${configData?.config?.apiBaseUrl}/api/insightsgraphnew/${currentRange}/${id}/${uuid}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );

      const xaxis = [];
      const yaxis = [];

      response.data.durationCounts.forEach((item) => {
        xaxis.push(item.label);
        yaxis.push(item.medianScore);
      });

      setChartData({
        series: [
          {
            name: "Score",
            data: yaxis,
          },
        ],
        options: {
          chart: {
            type: "bar", // Change 'area' to 'bar'
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              borderRadius: 5,
              horizontal: false,
              columnWidth: "45%",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 1,
            lineCap: "round",
          },
          grid: {
            row: {
              colors: ["#f3f3f3", "transparent"],
              opacity: 0.5,
            },
          },
          xaxis: {
            categories: xaxis,
          },
          colors: ["#42BA5C"],
          fill: {
            type: "solid",
          },
        },
      });
    } catch (error) {
      console.error('Error fetching insights graph:', error);
    }
  };


  useEffect(() => {

    if (id && uuid) {
      fetchinsightgraph();
    } else {
      console.error('Invalid id or uuid, skipping fetch');
    }
  }, [currentRange, id, uuid]); 

  return (
    <>
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={200}
        />
      </div>
    </>
  );
};

export default ScoreChart;
